import { CALENDAR_TASK_STATUS } from '@/app/(main)/calendar/consts/calendar-task-status';
import type { CalendarEvent } from '@/types/calendarTypes';

export function applyTaskStatusOptimisticUpdate(
  events: CalendarEvent[],
  taskId: string,
  completed: boolean
): CalendarEvent[] {
  const status = completed ? CALENDAR_TASK_STATUS.COMPLETED : CALENDAR_TASK_STATUS.OPEN;

  return events.map((event) => (event.taskId === taskId ? { ...event, status } : event));
}
